import React from 'react';
import { Icon, IconName } from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import classNames from 'classnames';

interface IProps {
	isVisible: boolean;
}

export const NoResultsFoundNew: React.FC<IProps> = ({ isVisible }) => (
	<div
		className={classNames('px-4 flex-1 flex items-center justify-center', { invisible: !isVisible })}
		data-test="NoResultsFound">
		<div className="w-full max-w-120 p-8 flex flex-col items-center gap-6">
			<Icon className="text-purple-03-new" name={IconName.emptyLarge} size="hero" />
			<div className="w-full flex flex-col gap-4">
				<Text
					translationNameSpace="listing"
					translationKey="noResultsFoundTitle"
					size="xl"
					weight="bold"
					align="center"
				/>
				<Text translationNameSpace="listing" translationKey="noResultsFoundDescription" align="center" />
			</div>
		</div>
	</div>
);
